import { TranslateModel } from '../translate.model';

export class AppMessage {
  public id: string;
  public toast: boolean;
  public message: string;
  public priority: 'error' | 'info' | 'warning' | 'success' | 'remove' | 'clear';
  public component: string;
  public meta: any;
  public translations: TranslateModel[];

  constructor(toast = true, message: string, priority: 'error' | 'info' | 'warning' | 'success' | 'remove' | 'clear',
              component: string, id?: string, meta?: any, translations?: TranslateModel[]) {
    this.toast = toast;
    this.message = message;
    this.priority = priority;
    this.component = component;
    this.id = id;
    this.meta = meta;
    this.translations = translations;
  }
}
